import { DecimalPipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ThemeColor } from '../../../../components/helpers';
import { UiModule } from '../../../../components/ui.module';
import { LocationWithPlan } from '../../../../types';
import { LocationProfileResponse } from '../../../../types/location-profile';

type CellParams = ICellRendererParams<LocationWithPlan> & { branchId: () => number };

@Component({
  selector: 'app-pan-cell-billing-portal-cell-profile',
  imports: [UiModule, MatTooltipModule, RouterModule, DecimalPipe],
  templateUrl: './billing-portal-cell-profile.component.html',
  styleUrl: './billing-portal-cell-profile.component.scss',
})
export class CellBillingPortalCellProfileComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }

  public locationProfileStatusColor(status: LocationProfileResponse['status']): ThemeColor {
    switch (status) {
      case 'Completed':
        return 'success';
      case 'InProgress':
        return 'warning';
      case 'Pending':
        return 'danger';
      case 'Unstarted':
        return 'default';
      default:
        return 'default';
    }
  }
}
